import React, { useContext } from "react";

import { BooleanField } from "@culturehq/components";

import { Trans, t } from "app/utils";
import { CreatomateContext } from "../../../../contexts/VideoStudioContext";

const BURN_SUBTITLES_MESSAGE = "The style changes applied to the subtitles will be lost, would you like to set burn subtitles off?";

const BurnSubtitleField: React.FC<{}> = () => {
  const { data: { burnSubtitles, subtitles }, handleUpdateData } = useContext(CreatomateContext);

  const handleBurnSubtitlesChange = (value: boolean) => {
    if (burnSubtitles) {
      // eslint-disable-next-line no-alert
      if (window.confirm(t(BURN_SUBTITLES_MESSAGE))) {
        handleUpdateData({ burnSubtitles: value });
      }
    } else {
      handleUpdateData({ burnSubtitles: value });
    }
  };

  return (
    <BooleanField
      className="boolean-option"
      disabled={subtitles.filter(subtitle => !subtitle.deleted).length === 0}
      name="checkbox"
      onChange={handleBurnSubtitlesChange}
      value={burnSubtitles}
    >
      {burnSubtitles ? (
        <span className="chq-cmk-on"><Trans>On</Trans></span>
      ) : (
        <span className="chq-cmk-off"><Trans>Off</Trans></span>
      )}
    </BooleanField>
  );
};

export default BurnSubtitleField;
